export interface WithdrawalHealthCheckItemsWrapper {
  items: WithdrawalHealthCheckItem[];
  totalResults: number;
}

export interface WithdrawalHealthCheckItem {
  agentId: string;
  agentName: string;
  agentInitials: string;
  agentAvatar: string;
  teamName: string;
  onMarketCount: number;
  withdrawnCount: number;
  withdrawnPercentage: number;
  risk: WithdrawalHealthRiskEnum;
}

export enum WithdrawalHealthRiskEnum {
  Low = 1,
  Medium = 2,
  High = 3,
}
